import { render } from "./entry.vue?vue&type=template&id=599c547f"
import script from "./entry.vue?vue&type=script&lang=js"
export * from "./entry.vue?vue&type=script&lang=js"
script.render = render

export default script